class Pictures {
	constructor() {
		const pictures = document.querySelectorAll(".picture-container");

		const svg =
			`<svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
				<path d="M10 10V0L0 10H10Z" />
			</svg>`;

		const before = `<div class="before">${svg}<span></span></div>`;
		const after = `<div class="after">${svg}<span></span></div>`;

		pictures.forEach(pict => {
			if (!pict.classList.contains("no-borders")) {
				pict.insertAdjacentHTML("afterbegin", before);
				pict.insertAdjacentHTML("beforeend", after);
			}

			const beforeDiv = pict.querySelector(".before");
			const afterDiv = pict.querySelector(".after");

			gsap.fromTo(beforeDiv, {
				width: '50%'
			}, {
				width: '20%',
				scrollTrigger: {
					trigger: pict,
					scrub: 0.8,
					start: "top bottom",
					end: "bottom top",
				},
			});

			gsap.fromTo(afterDiv, {
				width: '40%'
			}, {
				width: '60%',
				scrollTrigger: {
					trigger: pict,
					scrub: 0.8,
					start: "top bottom",
					end: "bottom top",
				},
			});
		});
	}
}